<template>
    <div class="homeRoot">
        <div class="main">
            <div class="tab" v-if="!RE.tabType">
                <div class="tab_view">
                    <img :src="getImage(RE.bannerType, 'tab')" alt="">
                    <img :class="{ 'top_btn' : true }" ref="top_btn" :src="getImage(RE.bannerType, 'top_btn')" alt="">
                    <div :class="{ 'top_click_btn' : true }" @click="onClickTopBtn('top_btn')"></div>
                </div>
            </div>
            <!-- banner 首图 -->
            <div class="reference">
                <img :src="getImage(RE.bannerType, 'banner')" alt="">
                <div :class="{ 'banner_wrap': true, 'new_banner_wrap': RE.bannerBtnType == 5 }">
                    <img :class="{ 'banner_btn': true }" :src="getImage(RE.bannerBtnType, 'modal_btn')" alt="">
                    <div class="click_btn" @click="onClickBanner"></div>
                    <div class="baner_z_w"></div>
                    <img :class="{ 'banner_hand' : true }" :src="getImage(RE.bannerType, 'modal_hand')" alt="">
                </div>
            </div>
            <!-- store 商店跳转 -->
            <div class="reference">
                <img v-once v-lazyload="getImage(RE.detailType, 'storeBg')" alt="">
                <div class="store_wrap">

                    <div class="store_title" ref="slideInElementRight0">
                        <img v-once v-lazyload="getImage(RE.detailType, 'store_title')" alt="">
                    </div>

                    <div class="store_game_wrap" ref="slideInElementLeft">
                        <img v-once v-lazyload="getImage(RE.detailType, 'store_game')" alt="">
                        <div ref="store_btn" class="store_btn" @click="onClickStore('store_btn')">
                            <img v-once v-lazyload="getImage(RE.detailType, 'store_btn')" alt="">
                        </div>
                    </div>

                    <div class="store_app_wrap" ref="slideInElementRight"  v-if="RE.language !== 'US'">
                        <img v-lazyload="getImage(RE.detailType, 'store_app')" alt="">
                        <div ref="app_btn" class="app_btn" @click="onClickApp('app_btn')">
                            <img v-once v-lazyload="getImage(RE.detailType, 'fb')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!-- feature 游戏特色 -->
            <div class="reference">
                <img v-lazyload="getImage(RE.detailType, 'featureBg')" alt="">
                <div class="feature_wrap">
                    <div style="opacity: 1;">
                        <div ref="slideInElementRightfeature0">
                            <img v-lazyload="getImage(RE.detailType, 'feature_title')" alt="">
                        </div>
                        <div ref="slideInElementLeftfeature1">
                            <img v-lazyload="getImage(RE.detailType, 'feature1')" alt="">
                        </div>
                        <div ref="slideInElementRightfeature2">
                            <img v-lazyload="getImage(RE.detailType, 'feature2')" alt="">
                        </div>
                    </div>
                </div>
            </div>
            <!-- swiper 轮播图 -->
            <div class="reference">
                <img v-lazyload="getImage(RE.detailType, 'swiperBg')" alt="">
                <div class="swiper_wrap" ref="swiperContainer">
                    <img v-lazyload="getImage(RE.detailType, 'swiper_title')" alt="">
                    <div class="sw_1_1_zw"></div>
                    <div id="carousel" :class="{ 'carousel' : true }">
                        <swiper v-if="swiperInitialized" :options="swiperOption" v-once>
                            <swiper-slide v-for="(image, index) in images" :key="index">
                                <div class="slide_border">
                                    <img class="slide_border_bg" :src="getImage(RE.detailType, 'swiperBorder')" alt="">
                                    <img class="slide_img" :src="getImage(RE.detailType, image)" :alt="'Image ' + (index + 1)">
                                </div>
                            </swiper-slide>
                            <div class="swiper-button-prev" slot="button-prev">
                                <img :class="{'cli_btn': true}" v-lazyload="getImage(RE.detailType, 'button_prev')" alt="">
                            </div>
                            <div class="swiper-button-next" slot="button-next">
                                <img :class="{'cli_btn': true}" v-lazyload="getImage(RE.detailType, 'button_next')" alt="">
                            </div>
                        </swiper>
                    </div>
                </div>
            </div>
            <div class="tab_type_T1_wrap" v-if="RE.tabType">
                <img :src="getImage(3, 'tab_T1')" alt="">
                <img ref="top_btn_T1" :src="getImage(3, 'top_btn_T1')" alt="">
                <div class="top_btn_T1" @click="onClickTopBtn('top_btn_T1')"></div>
            </div>
        </div>
        <!-- 弹窗 -->
        <div :class="{ 'modal_box': true }" v-show="showModal">
            <div class="top_wrap">
                <div ref="modalCloseAn" @click="onClickClose" :class="{ 'modal_close': true, 'modal_1_close': RE.modalType == 1, 'modal_5_close': RE.modalType == 4 || RE.modalType == 5 }">
                    <img v-lazyload="getImage(RE.modalBtnType, 'modal_close')" alt="">
                </div>
            </div>

            <div class="modal_main">
                <img ref="modalLogoAn" :class="{'modal_logo': true }" v-lazyload="getImage(RE.modalType, 'modal_logo')" alt="">

                <div ref="CountdownAn" :class="{'Countdown': true, 'new_4_Count':  RE.modalType == '4' }" v-if="RE.modalType == 2 || RE.modalType == 4">
                    <div class="num"><img v-lazyload="getImage(RE.modalType, 'timer')" alt="">
                        <div class="spanWrap">
                            <span>{{ hours.charAt(0) }}</span><span>{{ hours.charAt(1) }}</span>
                        </div>
                    </div>
                    <div class="span_w"><span></span><span></span></div>
                    <div class="num"><img v-lazyload="getImage(RE.modalType, 'timer')" alt="">
                        <div class="spanWrap">
                            <span>{{ minutes.charAt(0) }}</span><span>{{ minutes.charAt(1) }}</span>
                        </div>
                    </div>
                    <div class="span_w"><span></span><span></span></div>
                    <div class="num"><img v-lazyload="getImage(RE.modalType, 'timer')" alt="">
                        <div class="spanWrap">
                            <span>{{ seconds.charAt(0) }}</span><span>{{ seconds.charAt(1) }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div :class="{'modal_foot': true, 'modal_new_foot': RE.modalType == 1 || RE.modalType == 5, 'modal_6_foot': RE.modalType == 6 }">
                <img ref="modalBtnAn" :class="{ 'modal_btn' : true }" v-lazyload="getImage(RE.modalBtnType, 'modal_btn')" alt="">
                <div class="foot_btn" @click="onClickModal"></div>
                <img ref="modalHandAn" :class="{ 'modal_hand' : true }" v-lazyload="getImage(RE.modalBtnType, 'modal_hand')" alt="">
            </div>
        </div>
    </div>
</template>



<script>
import RE from '@/assets/replace.js'
import { v4 as uuidv4 } from 'uuid'
import queryString from 'query-string'
let parsed = queryString.parse(location.search || '') || {}
import { lazyLoadHandler } from '@/directives/lazyload';
import { TGA } from '@/utils/tga.js';
import { Channel } from '@/utils/channel.js';

export default {
    components: {
    },
    data() {
        return {
            RE,
            avifSupported: false,
            webpSupported: false,
            showModal: false,
            isChannelTrack: false,
            timeLeft: 86400,
            intervalId: '',
            images: [
                '1',
                '2',
                '3',
                '4',
                '5',
            ],
            swiperInitialized: false,
            swiperOption: {
                // autoplay: {
                    // delay: 3000, // Delay between transitions (in milliseconds)
                    // disableOnInteraction: false // Continue autoplay after user interactions
                // },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    // el: '.swiper-pagination',
                    // clickable: true
                },
                lazy: false, // 关闭 Swiper 的懒加载
                loop: true, // Enable looping
                effect: 'coverflow', // Slide effect
                grabCursor: true,
                centeredSlides: true,
                slidesPerView: "auto",
                coverflowEffect: {
                    rotate: 50,
                    stretch: 0,
                    depth: 100,
                    modifier: 1,
                    slideShadows: true,
                },
            }
        }
    },
    watch: {
        showModal(newValue) {
            const mainEl = this.$el.querySelector('.main');
            if (newValue) {
                document.body.classList.add('no-scroll');
                if (mainEl) mainEl.style.overflowY = 'hidden';
                this.startCountdown();
            } else {
                document.body.classList.remove('no-scroll');
                if (mainEl) mainEl.style.overflowY = 'auto';
                clearInterval(this.intervalId);
            }
        }
    },
    computed: {
        hours() {
            return Math.floor(this.timeLeft / 3600).toString().padStart(2, '0');
        },
        minutes() {
            return Math.floor((this.timeLeft % 3600) / 60).toString().padStart(2, '0');
        },
        seconds() {
            return (this.timeLeft % 60).toString().padStart(2, '0');
        }
    },
    mounted() {
        TGA.track('page_show', {});

        this.createObservers();

        if(this.RE.isPost){
            this.showModal = false;
            setTimeout(() => {
                this.loadAllImages();
                this.swiperInitialized = true;
            }, 3000);
            return
        }

        // 判断是否需要弹窗
        if(RE.isShowModal){
            this.showModal = true
        } else {
            setTimeout(() => {
                this.loadAllImages();
                this.swiperInitialized = true;
            }, 3000);
        }
    },
    created(){
        const { avifSupported, webpSupported } = this.detectImageSupport();

        this.avifSupported = avifSupported;
        this.webpSupported = webpSupported;
        let str = `${this.RE.game}_uuid`;
        let uniqueId = localStorage.getItem(str) ? localStorage.getItem(str) : uuidv4();
        localStorage.setItem(str, uniqueId);
        TGA.login(uniqueId);

        TGA.track('open_page', {});
    },
    methods: {
        startCountdown() {
            this.intervalId = setInterval(() => {
                if (this.timeLeft > 0) {
                    this.timeLeft--;
                } else {
                    clearInterval(this.intervalId);
                }
            }, 1000);
        },
        getImage(typ, val) {
            let type = typ;
            if(val == 'timer' && type > 7){
                type = 3;
            }

            if (process.env.NODE_ENV !== 'production') {
                return require(`../../../images/${type}/${this.RE.language}/${val}.png`)
            } else {
                if (this.avifSupported) {
                    return `${RE.imgsUrl}/images/${type}/${RE.language}/${val}.avif`;
                } else if (this.webpSupported) {
                    return `${RE.imgsUrl}/images/${type}/${RE.language}/${val}.webp`;
                } else {
                    return `${RE.imgsUrl}/images/${type}/${RE.language}/${val}.png`;
                }
            }
        },
        detectImageSupport(){
            // 检测 AVIF 支持
            const avifSupported = new Promise(resolve => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = 'data:image/avif;base64,AAAAIGZ0eXBhdmlmAAAAAGF2aWZtaWYxbWlhZk1BMUIAAADybWV0YQAAAAAAAAAoaGRscgAAAAAAAAAAcGljdAAAAAAAAAAAAAAAAGxpYmF2aWYAAAAADnBpdG0AAAAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAAAAQAAABppbmZlAgAAAAABAABhdjAxQ29sb3IAAAAAamlwcnAAAABLaXBjbwAAABRpc3BlAAAAAAAAAAIAAAACAAAAEHBpeGkAAAAAAwgICAAAAAxhdjFDgQ0MAAAAABNjb2xybmNseAACAAIAAYAAAAAXaXBtYQAAAAAAAAABAAEEAQKDBAAAACVtZGF0EgAKCBgANogQEAwgMg8f8D///8WfhwB8+ErK42A=';
            });
            
            // 检测 WebP 支持
            const webpSupported = new Promise(resolve => {
                const img = new Image();
                img.onload = () => resolve(true);
                img.onerror = () => resolve(false);
                img.src = 'data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=';
            });
            
            return { avifSupported, webpSupported };
        },
        onClickModal(){     //弹窗点击预约
            this.trackChannelTGA('popup_button_click');
        },
        onClickClose(){     //弹窗关闭按钮
            this.showModal = false;
            TGA.track('popup_close', {});
            this.loadAllImages();
            this.swiperInitialized = true;
        },
        onClickStore(val){  //二图商店预约
            const className = 'click-store';
            this.handleClick(val, className, () => {
                this.trackChannelTGA('page2_button_click');
            });
        },
        onClickApp(val){    //社媒
            const className = 'click-app';
            this.handleClick(val, className, () => {
                let url = this.RE.language == 'TW' ? this.RE.FB : this.RE.language == 'KR' ?  this.RE.naver : this.RE.X;
                window.open(url);
                TGA.track('page2_social_click', {});
            });
        },
        onClickTopBtn(val){     //点击头部按钮
            this.handleClick(val, 'click-top-btn', () => {
                this.trackChannelTGA('banner_click');
            });
        },
        onClickBanner(){    //点击首页按钮
            this.trackChannelTGA('page1_button_click');
        },
        trackChannelTGA(val){     //渠道上报

            if(this.RE.isPost){     //弹窗后置
                if(val == 'popup_button_click'){
                    TGA.track(val, {});
                    Channel.track();
                    window.open(this.RE.url);
                }else{
                    this.showModal = true;
                    TGA.track('popup_show', {});
                }
                return
            }
            
            return new Promise((resolve, reject) => {
                if(!this.isChannelTrack){
                    this.isChannelTrack = true;
                    Channel.track();
                }

                if (this.RE.pid == 'fb') {
                    TGA.track(val, {}).then(() => {
                        window.location.href = this.RE.url;
                        resolve();
                    })
                } else {
                    TGA.track(val, {})
                    window.open(this.RE.url);
                }
            });
        },
        handleClick(val, className, callback) {
            const button = this.$refs[val];
            button.classList.add(className);
            setTimeout(() => {
                button.classList.remove(className);
                if (callback) {
                    callback();
                }
            }, 300);
        },
        loadAllImages() {
            lazyLoadHandler();
        },
        createObservers() {
            const options = {
                root: null,
                rootMargin: '0px 0px -15% 0px',
                threshold: 0.1
            };
            const elements = [
                { ref: 'modalHandAn', animationClass: 'modalHandAn' },
                { ref: 'modalBtnAn', animationClass: 'modalBtnAn' },
                { ref: 'CountdownAn', animationClass: 'CountdownAn' },
                { ref: 'modalLogoAn', animationClass: 'modalLogoAn' },
                { ref: 'modalCloseAn', animationClass: 'modalCloseAn' },
                { ref: 'modalTitleAn', animationClass: 'modalTitleAn' },

                { ref: 'slideInElementRight0', animationClass: 'slide-in-right' },
                { ref: 'slideInElementLeft', animationClass: 'slide-in-left' },
                { ref: 'slideInElementRight', animationClass: 'slide-in-right' },
                { ref: 'slideInElementRightfeature0', animationClass: 'slide-in-right' },
                { ref: 'slideInElementLeftfeature1', animationClass: 'slide-in-left' },
                { ref: 'slideInElementRightfeature2', animationClass: 'slide-in-right' },
                
            ];

            elements.forEach(({ ref, animationClass }) => {
                const element = this.$refs[ref];
                if (element) {
                    const observer = new IntersectionObserver((entries) => this.handleIntersect(entries, animationClass), options);
                    observer.observe(element);
                }
            });
        },
        // 检查元素是否在视口内的辅助函数
        isInViewport(element) {
            const rect = element.getBoundingClientRect();
            return (
                rect.top >= 0 &&
                rect.left >= 0 &&
                rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                rect.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        },
        handleIntersect(entries, animationClass) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    entry.target.classList.add(animationClass);
                }
            });
        },
        getMobileOperatingSystem() {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;

            // 检查是否是 Android 设备
            if (/android/i.test(userAgent)) {
                return 'https://play.google.com/store/apps/details?id=com.habby.capybara&listing=cpp_01';
            }

            // 检查是否是 iOS 设备
            if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
                return 'https://apps.apple.com/app/capybara-go/id6596787726?ppid=05d397ce-b489-4e70-a713-a82023265e0b';
            }

            return 'https://apps.apple.com/app/capybara-go/id6596787726?ppid=05d397ce-b489-4e70-a713-a82023265e0b';
        },
    }
}
</script>

<style scoped lang="less">
@import "./home.less";
</style>